"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var TOGGLE_WIDTH = 34;
var TOGGLE_HEIGHT = 20;
var THUMB_WIDTH = 14;
var THUMB_HEIGHT = 14;
var FOCUS_WIDTH = 4;
exports.createMuiSwitchOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return ({
        root: {
            // This component has overflow `hidden`, so spacing has to account for the focus glow
            width: TOGGLE_WIDTH + FOCUS_WIDTH * 2,
            height: TOGGLE_HEIGHT + FOCUS_WIDTH * 2,
            padding: FOCUS_WIDTH,
            "--margin-y": spacing(4) - TOGGLE_HEIGHT / 2 - FOCUS_WIDTH + "px",
            "--margin-x": spacing(3) - FOCUS_WIDTH + "px",
            margin: "var(--margin-y) var(--margin-x)",
        },
        switchBase: {
            top: FOCUS_WIDTH,
            left: FOCUS_WIDTH,
            padding: 3,
            color: palette.common.white,
            borderRadius: "50%",
            transition: transitions.create(["left", "transform", "background-color"], {
                duration: transitions.duration.shortest,
            }),
            "&:hover": {
                backgroundColor: styles_1.fade(palette.common.white, 0.3),
            },
            "&$checked": {
                transform: "translateX(" + THUMB_WIDTH + "px)",
            },
            "&$checked + $track": {
                opacity: undefined,
            },
            "&$disabled": {
                color: palette.common.white,
                opacity: 0.5,
            },
            "&$disabled + $track": {
                opacity: undefined,
                backgroundColor: palette.action.disabled,
            },
            "&.Mui-focusVisible": {
                boxShadow: "unset",
                backgroundColor: "unset",
            },
        },
        colorPrimary: {
            "&$checked": {
                color: undefined,
                "&:hover": {
                    backgroundColor: undefined,
                },
                "&$disabled + $track": {
                    backgroundColor: styles_1.fade(palette.primary.main, 0.25),
                },
            },
            "&$disabled": {
                color: undefined,
            },
            "&$disabled + $track": {
                backgroundColor: undefined,
            },
        },
        thumb: {
            width: THUMB_WIDTH,
            height: THUMB_HEIGHT,
            boxShadow: undefined,
        },
        track: {
            opacity: undefined,
            borderRadius: TOGGLE_HEIGHT / 2,
            backgroundColor: palette.secondary.main,
            ".Mui-focusVisible + &": {
                boxShadow: "0 0 0 " + FOCUS_WIDTH + "px " + styles_1.fade(palette.primary.main, 0.25),
            },
        },
        // TODO: Update when VDL has designs for "small". Without this, setting it to small will use default styles
        sizeSmall: {
            width: undefined,
            height: undefined,
            padding: undefined,
            "& $thumb": {
                width: undefined,
                height: undefined,
            },
            "& $switchBase": {
                padding: undefined,
                "&$checked": {
                    transform: undefined,
                },
            },
        },
    });
};
//# sourceMappingURL=MuiSwitch.js.map